import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://128.199.226.158", // Replace with your API base URL
});

apiClient.interceptors.request.use(
    (config) => {
        //TODO Remove hardcoded apiKey 
        const apiKey = '1234';
        config.headers['api_key'] = apiKey;
        return config
    },
    (error) => {
      return Promise.reject(error);
    }
  );
export default apiClient;